import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, of} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {ApiCommands, getToken as commonGetToken} from '../api.commands';
import {Router} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    apiUrl: string = environment.apiUrl;
    private currentUserSubject = new BehaviorSubject<any>(null);
    readonly currentUser$ = this.currentUserSubject.asObservable();

    private isLoggedInSubject = new BehaviorSubject<boolean>(this.checkToken());
    readonly isLoggedIn$ = this.isLoggedInSubject.asObservable();

    constructor(
        private http: HttpClient,
        private apiCommands: ApiCommands,
        private router: Router
    ) {
    }

    refreshToken() {
        return this.http.post(this.apiUrl + 'refresh/token', {refreshToken: this.getRefreshToken()}).pipe(
            tap((tokens: any) => {
                localStorage.setItem('ptToken', tokens.payload.token);
                localStorage.setItem('ptRefreshToken', tokens.payload.refreshToken);
            }),
            catchError((error) => {
                this.logout();
                this.router.navigate(['/login']);
                return of(false);
            })
        );
    }

    checkToken(): boolean {
        return (localStorage.getItem('ptToken')) ? true : false;
    }

    public get isLoggedIn(): boolean {
        return this.isLoggedInSubject.value;
    }

    public get currentUser(): any {
        return this.currentUserSubject.value;
    }

    signup(body: any) {
        return this.http.post(this.apiUrl + 'signup', body);
    }

    login(body: any) {
        return this.http.post(this.apiUrl + 'login', body).pipe(map((res: any) => {
            if(res.payload['reset-password']){
                return res;
            }
            localStorage?.setItem('ptToken', res.payload.token);
            localStorage?.setItem('ptRefreshToken', res.payload.refreshToken);
            return res
        }));
    }

    current() {
        let headers = this.getAuthHeaders(this.getToken());
        return this.http.get(this.apiUrl + 'current', headers).pipe(map((res: any) => {
            this.currentUserSubject.next(res.payload[0]);
            return res.payload[0];
        }));
    }

    logout() {
        localStorage.clear();
        this.isLoggedInSubject.next(false);
        this.currentUserSubject.next(null);
    }

    getRefreshToken() {
        return localStorage.getItem('ptRefreshToken') || '';
    }

    getToken() {
        return localStorage.getItem('ptToken') || '';
    }

    getAuthHeaders(auth: string) {
        return {headers: {Authorization: auth, 'Content-Type': ('application/json')}};
    }


    forgotPassword(body: any) {
        return this.http.post(this.apiUrl + 'forgotPassword', body);
    }

    resetPassword(body: any) {
        return this.http.post(this.apiUrl + 'resetPassword', body);
    }
}
